'use client'
import useAppStore from '@/context/app-context'
import React, { useEffect } from 'react'

interface ConfigInitializerProps {
  children: React.ReactNode
}

/**
 * 配置初始化组件
 * 在应用启动时加载全局配置
 */
export const ConfigInitializer: React.FC<ConfigInitializerProps> = ({ children }) => {
  const { loadAppConfig } = useAppStore()

  // 应用启动时加载配置  
  useEffect(() => { loadAppConfig() }, [loadAppConfig])

  return <>{children}</>
}